import { checkGoogleConnection } from './methods/check-connection'
import { getAccountsAndProperties } from './methods/get-accounts-and-properties'
import { saveAccountSelection } from './methods/save-account-selection'
import { savePropertySelection } from './methods/save-property-selection'
import { checkDuplicateAccount } from './methods/check-duplicate-account'

export const googleService = {
  checkGoogleConnection,
  getAccountsAndProperties,
  saveAccountSelection,
  savePropertySelection,
  checkDuplicateAccount
}

export {
  checkGoogleConnection,
  getAccountsAndProperties,
  saveAccountSelection,
  savePropertySelection,
  checkDuplicateAccount
}
